import React, {useEffect, useMemo, useState} from 'react'
import PropTypes from 'prop-types';
import panels, {isInitialHidden} from './part1.panels.components'
import {setStepperState} from 'redux/actions'
import {connect} from 'react-redux'
import ArrowIcon from '@material-ui/icons/KeyboardArrowUp'
import RefreshIcon from '@material-ui/icons/Refresh'
import MailIcon from '@material-ui/icons/Mail';
import ListIcon from '@material-ui/icons/List';
import DemandService from 'services/DemandService';
import PublishService from 'services/PublishService';
import ModificationService, {modify} from 'services/ModificationService';
import {isDemandModification, isDemandNew, isDemandOfferCollection, isDemandPreparing} from "libs/getDemandStatus";
import Confirm from "components/popup/confirm/Confirm";
import Alert from "components/popup/alert/Alert";
import createButton, {createSubmitFormButton} from "components/complex/floatingMenu/createButton";
import RouterPath from "libs/RouterPath";
import SaveIcon from "@material-ui/icons/Save";
import useSnackbar from "hooks/useSnackbar";
import Tr from 'translations/Translations';

import isCancelModificationButtonActive from "libs/isCancelModificationButtonActive";
import AccordionPart from "pages/purchaser/MyProcedure/scenes/components/AccordionPart";
import HeaderService from "services/HeaderService";
import reduxStore from "redux/store";
import DemandSectionsService from "services/DemandSectionsService";
import DemandRelatedObjectsPopup from "components/popup/relatedObjects/DemandRelatedObjectsPopup";
import PrivilegeService from "services/PrivilegeService";
import StatisticsService from "services/StatisticsService";
import RfxRoundService from "services/RfxRoundService";
import NationalNoticeService from "services/NationalNoticeService";
import {DemandValidation} from "../../../../../constants/DemandValidation";


function Part1(
    {
        stepperState,
        setStepperState,
        steps,
        match,
        location,
        demandValidation,
        demandHeader,
        ojsPublicationStatus,
        bzpContractNoticeStatus,
        rfxPrivileges = {},
        demandPrivileges = {}
    }) {

    const [openCancelModificationPopup, setOpenCancelModificationPopup] = useState(false);
    const [relatedObjectPopup, setRelatedObjectPopup] = useState(false);
    const [working, setWorking] = useState(true);
    const [openDemandPublicLinkPopup, setOpenDemandPublicLinkPopup] = useState(false);
    const {enqueueSuccessSnackbar} = useSnackbar();

    //const scrollPosition = useWindowScroll();
    //const [nodeRef, topOffset] = useNodeTopPosition([scrollPosition]);
    const id = match.params.id;

    // eslint-disable-next-line
    const isModification = useMemo(() => isDemandModification(), [demandHeader]);
    // eslint-disable-next-line
    const isPreparing = useMemo(() => isDemandPreparing(), [demandHeader]);
    // eslint-disable-next-line
    const isNew = useMemo(() => isDemandNew(), [demandHeader]);
    // eslint-disable-next-line
    const isExPost = useMemo(() => demandHeader && demandHeader.exPost, [demandHeader]);
    // eslint-disable-next-line
    const isOfferCollection = useMemo(() => isDemandOfferCollection(), [demandHeader]);


    useEffect(() => {
        DemandService.getValidate(id).then(() => setWorking(false));
        if (id !== undefined && id > 0) {
            DemandService.getBuyerPrivileges(id);
            if (isPreparing === false && isNew === false && isExPost === false) {
                StatisticsService.getCurrentRound(id).then((resp) => {
                    if(resp) RfxRoundService.getBuyerPrivileges(resp.id);
                })
            }
        }

        return () => {
            reduxStore.dispatch(setStepperState(null));
            DemandSectionsService.clearDemandValidationResources();
            HeaderService.clear();
            PrivilegeService.cleanupPrivileges(PrivilegeService.DEMAND_PRIVILEGE_STORE_KEY)
            PrivilegeService.cleanupPrivileges(PrivilegeService.RFX_PRIVILEGE_STORE_KEY)
            StatisticsService.clearCurrentRound();
        };
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (id !== undefined && id > 0) {

            if (isPreparing) {
                if (demandHeader?.noticeOjsType === true) {
                    PublishService.checkPublishOjs(id);
                } else if(demandHeader?.noticeBzpType === true) {
                    NationalNoticeService.getContractNoticeStatus(id);
                }
            } else if (isModification) {
                if (demandHeader?.noticeOjsType === true) {
                    ModificationService.noticeOjsStatus(id);
                } else if(demandHeader?.noticeBzpType === true) {
                    NationalNoticeService.getContractModificationNoticeStatus(id);
                }
                ModificationService.isDemandChanged(id)
            }
        }
        return () => {
            PublishService.clearOjsStatus();
            NationalNoticeService.clearResources(NationalNoticeService.BZP_CONTRACT_NOTICE_STATUS);
            ModificationService.clearDemandChanged();
        }
        // eslint-disable-next-line
    }, [id, demandHeader])


    const handleModifyClick = () => {
        setWorking(true);
        modify(id).then(() => {
            if (stepperState !== null) {
                setStepperState(null);
            }
            DemandService.getValidate(id).then(() => setWorking(false));
        });
    };

    const updateDemandNumber = () => {
        setWorking(true);
        DemandService.updateNumber(id).then((resp) => {
            if (resp.result) {
                setWorking(false);
                HeaderService.get(id);
                enqueueSuccessSnackbar(Tr('update_demand_number_success'));
            }
        });
    }

    const isPublicationSectionEditable = () => {
        return demandValidation?.find(x => x.section === DemandValidation.PUBLICATION)?.editable;
    }

    const getNavigationBarButtons = () => {
        const buttons = [];
        if (id) {
            buttons.push(createButton('email_list', () => {
                const href = RouterPath.createPath(RouterPath.myProcedure.steps.MP_EMAIL_LIST_ID, {id: id});
                RouterPath.redirect(href)
            }, undefined, MailIcon, 'primary', false, true));

            if (demandHeader && (demandHeader.hasPlanItems || demandHeader.hasPurchaseRequests)) {
                buttons.push(createButton('related_objects', () => setRelatedObjectPopup(true),
                    "outlined", ListIcon, 'primary', false, true));

            }
        }

        if (!isExPost) {
            if (isPreparing && demandHeader && demandHeader.demandPublicLink) {
                buttons.push(createButton('demand_public_link_button', () => {
                    setOpenDemandPublicLinkPopup(true);
                }, undefined, undefined, 'primary', false, true));
            }

            if (isModification) {
                buttons.push(createButton("modification_cancel", () => {
                    setOpenCancelModificationPopup(true)
                }, undefined, undefined, 'primary', !isCancelModificationButtonActive(demandValidation, ojsPublicationStatus, bzpContractNoticeStatus) || !isPublicationSectionEditable()));
            }

            if (isOfferCollection) {
                buttons.push(createButton("modify", handleModifyClick, undefined, undefined, "primary", (!demandPrivileges.MODIFY || !demandHeader || !isOfferCollection)));
            }
        }

        if (demandHeader && demandHeader.showUpdateNumber && demandPrivileges.EDIT) {
            buttons.push(createButton("update_number",
                updateDemandNumber,
                undefined,
                RefreshIcon,
                'primary',
                stepperState !== null,
                false)
            );
        }

        const isSaveButton = isNew || isPreparing || isModification || !stepperState || stepperState === "mp_1_siwz" || stepperState === "mp_1_espd" || stepperState === "mp_1_commission" || stepperState === "mp_1_preparing_additional_info";

        buttons.push(createSubmitFormButton(isSaveButton ? "save" : "close",
            undefined,
            isSaveButton ? SaveIcon : ArrowIcon,
            'primary',
            stepperState === null,
            isSaveButton)
        );

        return buttons;
    }


    const navigationBarButtons = getNavigationBarButtons();

    const rp = RouterPath.myProcedure;
    const handleConfirmCancelModification = () => {
        setOpenCancelModificationPopup(false);
        setWorking(true);
        ModificationService.cancel(id).then((resp) => {
            if (resp) {
                setWorking(false);
                const href = RouterPath.createPath(rp.steps.MP_2_ID, {id});
                RouterPath.redirect(href);
            }
        });
    };

    const filterSteps = () => {
        const params = new URLSearchParams(location.search);
        return steps.filter(x => !isInitialHidden(x, params.get("procedureType"), params.get("passive"), params.get("exPost")))
    }

    const stepsFiltered = !!id ? steps : filterSteps();

    return (<>
            <AccordionPart working={working} navigationBarButtons={navigationBarButtons} steps={stepsFiltered} panels={panels}/>
            <Confirm
                open={openCancelModificationPopup}
                onConfirm={handleConfirmCancelModification}
                onCancel={() => setOpenCancelModificationPopup(false)}
                confirmText="modification_cancel_popup_text"
            />
            {demandHeader &&
            <Alert
                title='demand_public_link'
                open={openDemandPublicLinkPopup}
                onClose={() => setOpenDemandPublicLinkPopup(false)}
                confirmText={demandHeader.demandPublicLink || ""}
                maxWidth='md'
            />
            }
            {
                relatedObjectPopup &&
                <DemandRelatedObjectsPopup demandId={id} onClose={() => setRelatedObjectPopup(false)}/>
            }
        </>
    )
}

Part1.propTypes = {
    classes: PropTypes.any,
}

export default connect((state) => ({
    demandHeader: state.resources.demandHeader,
    stepperState: state.stepper.state,
    steps: state.stepper.steps[0].steps,
    demandValidation: state.resources.demandValidation,
    form: state.form,
    ojsPublicationStatus: state.resources.ojsPublicationStatus,
    bzpContractNoticeStatus: state.resources.bzpContractNoticeStatus,
    rfxPrivileges: state.privileges[PrivilegeService.RFX_PRIVILEGE_STORE_KEY],
    demandPrivileges: state.privileges[PrivilegeService.DEMAND_PRIVILEGE_STORE_KEY],
}), {
    setStepperState
})(Part1);